import { useMutation } from 'react-query';
import { client } from '@frontend/features/common/services';

interface SendTemplateWithFilePayload {
  file: File;
  clientId: string;
  templateName: string;
  languageCode: string;
  bodyParameters?: Array<{
    type: string;
    [key: string]: any;
  }>;
}

export const useSendTemplateWithFile = (agencyId?: number | null) =>
  useMutation((payload: SendTemplateWithFilePayload) => {
    if (!agencyId) {
      return Promise.reject(new Error('Agency ID is required'));
    }

    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('clientId', payload.clientId);
    formData.append('templateName', payload.templateName);
    formData.append('languageCode', payload.languageCode);
    
    if (payload.bodyParameters) {
      formData.append('bodyParameters', JSON.stringify(payload.bodyParameters));
    }

    return client.post(
      `whatsapp/send-message-file-template/${agencyId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  });
  